module.exports = __webpack_public_path__ + "static/img/4.45b9238.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/sp/4.png
// module id = dQ8R
// module chunks = 0